import { render, staticRenderFns } from "./UserImageContainer.vue?vue&type=template&id=2182e6d8&scoped=true&"
import script from "./UserImageContainer.vue?vue&type=script&lang=js&"
export * from "./UserImageContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserImageContainer.vue?vue&type=style&index=0&id=2182e6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182e6d8",
  null
  
)

export default component.exports